/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EditionEnum } from './editionEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface ReportedCommerce { 
    reported_edition?: EditionEnum;
    /**
     * Reported Expiry date
     */
    reported_expiry_date?: Date;
    reported_mode?: CommerceModeEnum;
}
export namespace ReportedCommerce {
}


